import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DemoListComponent } from './demo-list/demo-list.component';
import { DemoAuditComponent } from './demo-audit/demo-audit.component';
import {DemoRoutingModule} from './demo-routing.module';
import {DemoService} from './demo.service';
import {ShareModule} from '../share/share.module';
import {ProfileModule} from '../profile/profile.module';

@NgModule({
  imports: [
    CommonModule,
    DemoRoutingModule,
    ShareModule,
    ProfileModule
  ],
  declarations: [
    DemoAuditComponent
  ],
  exports: [

  ],
  providers: [
    DemoService
  ]
})
export class DemoModule { }
